import React, { useState } from 'react';
import './ask.css';
import { Backdrop, Box, Modal, Fade } from '@mui/material';
import { useLandingPageQuery } from '../../slice/adminDataApiSlice';
import { generatePublicUrl } from '../../config';
import { useBookSlotMutation, useCounsellorDetQuery } from '../../slice/authApiSlice';
import { toast, ToastContainer } from 'react-toastify';
import Comming from '../Commingsoon/Comming';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  height: 500,
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
};

function AllAsk() {
  const [open, setOpen] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [selectedExpert, setSelectedExpert] = useState(null);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phNumber, setPhNumber] = useState('');
  const [slotDate, setSlotDate] = useState('');
  const [imageErrorMap, setImageErrorMap] = useState({});

  const { data, isLoading } = useCounsellorDetQuery();
  
  const [bookSlot, { isLoading: bookLoading }] = useBookSlotMutation();

  const handleOpen = (expert) => {
    setSelectedExpert(expert);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedExpert(null);
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) {
      setPhNumber(value);
    }
  };

  const handleImageError = (index) => {
    setImageErrorMap((prev) => ({ ...prev, [index]: true }));
  };

  const handleBooking = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!selectedExpert) return;

    if (!name || !email || !phNumber || !slotDate) {
      toast.error('All fields are required');
      return;
    }

    if (!emailRegex.test(email)) {
      toast.error('Please enter a valid email address');
      return;
    }

    const payload = {
      name,
      email,
      phNumber,
      counselorName: selectedExpert.name,
      counselorDegi: selectedExpert.designation,
      slotDate,
    };

    try {
      const res = await bookSlot(payload).unwrap();
      if (res) {
        toast.success("Successfully booked");
        setName('');
        setEmail('');
        setPhNumber('');
        setSlotDate('');
        handleClose();
      }
    } catch (error) {
      console.error('Booking Error:', error);
      toast.error('Failed to book a session. Please try again.');
    }
  };

  return (
    <div className="blog-center">
    <div className="experts-container1">
      <section className="expert-Inr1">
        <div className="experts-cards1">
          {data?.length > 0 ? (
            data.map((expert, index) => {
              const initials =
                (expert?.name?.split(' ')[0]?.[0] ?? '') +
                (expert?.name?.split(' ')[1]?.[0] ?? '');
              const profilePic = generatePublicUrl(expert?.profilePictures?.[0]?.img);
              const hasImageError = imageErrorMap[index];

              return (
                <div className="expert-card" key={index}>
                  <div className="expert-image-wrapper">
                    {!hasImageError && expert?.profilePictures?.[0]?.img ? (
                      <img
                        className="expert-img"
                        src={profilePic}
                        alt={expert.name}
                        onError={() => handleImageError(index)}
                      />
                    ) : (
                      <div className="expert-initials">{initials.toUpperCase()}</div>
                    )}
                  </div>
                  <div className="expert-info">
                    <h3>{expert.name}</h3>
                    <p>{expert.expert} | {expert.yearExp} + Years of experience</p>
                    <div className="rating">⭐ {expert.rating}</div>
                  </div>
                  <div className="expert-actions">
                    <button className="chat-btn" onClick={() => setPopupOpen(true)}> 
                      <p>Chat</p> <h5>{expert.chatPrice} coins</h5>
                    </button>
                    <button className="voice-btn" onClick={() => setPopupOpen(true)}>
                      <p>Voice Call</p> <h5>{expert.voiceCallPrice} coins</h5>
                    </button>
                    <hr />
                    <button className="session-btn" onClick={() => setPopupOpen(true)}>
                      <p>Book a Session</p> <h5>{expert.sessionPrice} coins</h5>
                    </button>
                  </div>
                </div>
              );
            })
          ) : (
            <p>No experts available at the moment.</p>
          )}
        </div>
      </section>

      {/* Booking Modal */}
      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{ backdrop: { timeout: 500 } }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <section className="askModal">
              <h2>Book your slot now</h2>
              <p>Book a session with <strong>{selectedExpert?.name}</strong>.</p>

              <input
                type="text"
                placeholder="Enter your name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                style={{
                  border: '2px solid black',
                  borderRadius: '4px',
                  padding: '8px',
                  width: '100%',
                  fontSize: '16px',
                  marginBottom: '10px',
                  outline: 'none',
                }}
              />
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{
                  border: '2px solid black',
                  borderRadius: '4px',
                  padding: '8px',
                  width: '100%',
                  fontSize: '16px',
                  marginBottom: '10px',
                  outline: 'none',
                }}
              />
              <input
                type="text"
                placeholder="Enter your phone number"
                value={phNumber}
                onChange={handlePhoneChange}
                style={{
                  border: '2px solid black',
                  borderRadius: '4px',
                  padding: '8px',
                  width: '100%',
                  fontSize: '16px',
                  marginBottom: '10px',
                  outline: 'none',
                }}
              />
              {phNumber.length > 0 && phNumber.length < 10 && (
                <span style={{ color: 'red', fontSize: '12px', marginTop: "-20px" }}>
                  Phone number must be 10 digits.
                </span>
              )}
              <input
                type="datetime-local"
                value={slotDate}
                onChange={(e) => setSlotDate(e.target.value)}
                style={{
                  border: '2px solid black',
                  borderRadius: '4px',
                  padding: '8px',
                  width: '100%',
                  fontSize: '16px',
                  outline: 'none',
                }}
              />
              <button
                onClick={handleBooking}
                style={{
                  marginTop: '15px',
                  padding: '10px',
                  width: '100%',
                  backgroundColor: 'black',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
              >
                Book now
              </button>
            </section>
          </Box>
        </Fade>
      </Modal>

      
      <Comming open={popupOpen} handleClose={() => setPopupOpen(false)} />

      <ToastContainer />
    </div>
    </div>
  );
}

export default AllAsk;


